import userEvent from '@testing-library/user-event'
import { VoteRequest } from '../requests/VoteRequest'

class voteStore {
  voteDetail = []

  createVote = data => {
    return new Promise((resolve, reject) => {
      VoteRequest.createVote(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getVoteDetail = workCode => {
    return new Promise((resolve, reject) => {
      VoteRequest.getVoteDetail(workCode)
        .then(response => {
          this.voteDetail = response.data.users.map(user => ({
            ...user,
            permission: 'USER',
            assignee_type: 'USER',
          }))
          // console.log('response', response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getVoteDetailResponse = workCode => {
    return new Promise((resolve, reject) => {
      VoteRequest.getVoteDetail(workCode)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  updatePersonVote = (userCode, data) => {
    return new Promise((resolve, reject) => {
      VoteRequest.updatePersonVote(userCode, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  updateVote = (userCode, data) => {
    return new Promise((resolve, reject) => {
      console.log(data)
      VoteRequest.updateVote(userCode, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Clear store */
  clearStore = () => {
    this.voteDetail = []
  }
}

export default new voteStore()
